<template>
  <div class="container-fluid ms-3">
    <div class="row d-flex justify-content-between">
      <div class="col-4">
        <i class="mdi mdi-account-box-outline mdi-48px"></i>
        <table v-for="item in members" :key="item.id" class="table" density="compact" style="color:black">
          <tr>
            <td>Full Name </td>
            <td> {{ item.name }}</td>
          </tr>
          <tr>
            <td>Gender </td>
            <td> {{ item.gender }} </td>
          </tr>
          <tr>
            <td> Telephone </td>
            <td> {{ item.telephone }} </td>
          </tr>
          <!-- <tr><td> Age </td><td> {{ getAge(item.date_of_birth) }} yrs </td></tr> -->
          <tr>
            <td> Address </td>
            <td> {{ item.address }} </td>
          </tr>
          <tr>
            <td> NIN </td>
            <td>{{ item.nin }}</td>
          </tr>
        </table>
        <span class="h6"> Savings Balance</span>: <span class="text-dark h5"> <b>{{ commas(savingbalance) }} {{
          userData.currency }}</b></span>
      </div>
      <div class="col-4">
        <br><span v-if="userData.logo != 0"><img :src="getFiles(userData.logo)" height="50" /></span>
        <span v-else><img src="@/assets/images/default.jpg" height="50" /></span><br>
        <h4 style="color:black" class="text-uppercase">{{ userData.business }}</h4>
        <span style="color:black;font-size:13px">Location : {{ userData.location }}</span><br>
        <span style="color:black;font-size:13px">Telephone : {{ userData.contact }}</span><br>
        <span style="color:black;font-size:13px">Email : {{ userData.email }}</span><br>
        <span style="color:black;font-size:13px">Website : www.namirembedioceseyoungchristiansacco.com</span><br>
      </div>
    </div>
    <br>
    <h4 class="my-2 text-center text-decoration-underline">Member Profile</h4>

    <h4>Registration Fees</h4>
    <table class="table table-sm mt-2" style="color: black;" density="compact">
      <thead>
        <tr>
          <th>Amount</th>
          <th>Payment Mode</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in registrationfees" :key="item.id">
          <td>{{ commas(item.amount) }}</td>
          <td>{{ item.mode_of_payment.name }} - {{ item.reference }}</td>
          <td>{{ item.date_of_payment }}</td>
        </tr>
      </tbody>
    </table>

    <br>
    <h4>Subscription Fees</h4>
    <table class="table table-sm mt-2" style="color: black;" density="compact">
      <thead>
        <tr>
          <th>Amount</th>
          <th>Payment Mode</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in membershipfees" :key="item.id">
          <td>{{ commas(item.amount) }}</td>
          <td>{{ item.mode_of_payment.name }} - {{ item.reference }}</td>
          <td>{{ item.date_of_payment }}</td>
        </tr>
      </tbody>
    </table>
    <b>Total Subscriptions : {{ commas(totalsubscription) }}</b>

    <br><br>
    <h4>Savings</h4>
    <table class="table table-sm mt-2" style="color: black;" density="compact">
      <thead>
        <tr>
          <th>Amount</th>
          <th>Payment Mode</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in savings" :key="item.id">
          <td>{{ commas(item.amount) }}</td>
          <td>{{ item.mode_of_payment.name }} - {{ item.reference }}</td>
          <td>{{ item.date_of_payment }}</td>
        </tr>
      </tbody>
    </table>
    <b>Total Savings : {{ commas(totalsavings) }}</b>

    <br><br>
    <h4>Withdraws</h4>
    <table class="table table-sm mt-2" style="color: black;" density="compact">
      <thead>
        <tr>
          <th>Amount</th>
          <th>Charges</th>
          <th>Payment Mode</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in withdraws" :key="item.id">
          <td>{{ commas(item.amount) }}</td>
          <td>{{ commas(item.charges) }}</td>
          <td>{{ item.mode_of_payment.name }} - {{ item.reference }}</td>
          <td>{{ item.withdraw_date }}</td>
        </tr>
      </tbody>
    </table>
    <div class="row">
      <div class="col">
        <b>Total Withdraws : {{ commas(totalwithdraws) }}</b>
      </div>
      <div class="col text-center">
        <b>Total Charges : {{ commas(totalcharges) }}</b>
      </div>
      <div class="col"></div>
    </div>

    <br><br>
    <h4>Shares</h4>
    <table class="table table-sm mt-2" style="color: black;" density="compact">
      <thead>
        <tr>
          <th>Amount</th>
          <th>Shares</th>
          <th>Payment Mode</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in shares" :key="item.id">
          <td>{{ commas(item.amount) }}</td>
          <td>{{ commas(item.share) }}</td>
          <td>{{ item.mode_of_payment.name }} - {{ item.reference }}</td>
          <td>{{ item.date_of_payment }}</td>
        </tr>
      </tbody>
    </table>
    <b>Total Shares : {{ commas(totalshares) }}</b>

    <br><br>
    <h4>Loans</h4>
    <table class="table table-sm mt-2" style="color: black;" density="compact">
      <thead>
        <tr>
          <th>Loan</th>
          <th>Amount</th>
          <th>Interest</th>
          <th>Payback</th>
          <th>Paid</th>
          <th>Disbursement Date</th>
          <th>Full Payment</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in loans" :key="item.id">
          <td>{{ item.loan_type.name }} <br><small> {{ item.loan_type.rate }}% {{ item.loan_type.period }} days</small>
          </td>
          <td>{{ commas(item.amount) }}</td>
          <td>{{ commas(item.interest) }}</td>
          <td>{{ commas(item.payback) }}</td>
          <td>{{ commas(item.paid) }}</td>
          <td>{{ item.disbursement_date }}</td>
          <td>{{ item.expirydate }}</td>
          <td>
            <b v-if="item.status == '1'">Applied</b>
            <b v-else-if="item.status == '2'">Approved</b>
            <b v-else-if="item.status == '3'">Running</b>
            <b v-else-if="item.status == '4'">Closed</b>
            <b v-else-if="item.status == '5'">Written Off</b>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="row">
      <div class="col">
        <b>Total Loans : {{ commas(totalloan) }}</b>
      </div>
      <div class="col text-center">
        <b>Total Paid : {{ commas(totalpaid) }}</b>
      </div>
      <div class="col"></div>
    </div>

    <div class="text-center my-3">
      <br>
      <p style="color:black;font-size:13px">Printed by : {{ userData.username }}
        <br> {{ new Date().toLocaleDateString('en-US', options) }}
      </p>
      <center><qr-code text="Namirembe Diocese Young Sacco" :size="50" error-level="L"></qr-code></center>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Member Profile",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  data() {
    return {
      title: "Member Profile",
      items: [{ text: "Dashboard", to: "/", }, { text: "Members", active: true, },],
      userData: JSON.parse(localStorage.getItem("user")),
      options: { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "numeric" },
      members: [],
      savings: [], savingbalance: '',
      withdraws: [],
      shares: [],
      loans: [],
      transfers: [],
      registrationfees: [],
      membershipfees: [],
    };
  },
  created() {
    this.showmember();
    this.showsavings();
  },
  computed: {
    totalsubscription() { var total = 0; this.membershipfees.forEach((item) => { var item_total = item.amount; total = Number(total) + Number(item_total); }); return total },
    totalsavings() { var total = 0; this.savings.forEach((item) => { var item_total = item.amount; total = Number(total) + Number(item_total); }); return total },
    totalwithdraws() { var total = 0; this.withdraws.forEach((item) => { var item_total = item.amount; total = Number(total) + Number(item_total); }); return total },
    totalcharges() { var total = 0; this.withdraws.forEach((item) => { var item_total = item.charges; total = Number(total) + Number(item_total); }); return total },
    totalshares() { var total = 0; this.shares.forEach((item) => { var item_total = item.amount; total = Number(total) + Number(item_total); }); return total },
    totalloan() { var total = 0; this.loans.forEach((item) => { var item_total = item.amount; total = Number(total) + Number(item_total); }); return total },
    totalpaid() { var total = 0; this.loans.forEach((item) => { var item_total = item.paid; total = Number(total) + Number(item_total); }); return total },
  },
  methods: {
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    getAge(dateString) {
      let birth = new Date(dateString); let now = new Date(); let beforeBirth = ((() => { birth.setDate(now.getDate()); birth.setMonth(now.getMonth()); return birth.getTime() })() < birth.getTime()) ? 0 : 1;
      return now.getFullYear() - birth.getFullYear() - beforeBirth + 1;
    },
    getFiles(name) {
      let url = axios.defaults.baseURL;
      let imagelink = (url).slice(0, -3) + "logos/" + name;
      return imagelink;
    },
    async showmember() {
      this.member_id = this.$route.query.id;
      let url = `/memberprofile/${this.member_id}`;
      await axios.get(url).then((response) => {
        this.members = response.data.members;
      });
    },
    async showsavings() {
      this.member_id = this.$route.query.id;
      let url = `/profilesavings/${this.member_id}`;
      await axios.get(url).then((response) => {
        this.savings = response.data.savings;
        this.showwithdraw();
        this.showshares();
        this.showloans();
        this.showregistration();
        this.showmembership();
        this.FindBalance();
      });
    },
    async FindBalance() {
      this.member_id = this.$route.query.id;
      let url = `/savingsbalance/${this.member_id}`;
      await axios.get(url).then((response) => {
        this.savingbalance = response.data.balance;
      });
    },
    async showwithdraw() {
      this.member_id = this.$route.query.id;
      let url = `/profilewithdraws/${this.member_id}`;
      await axios.get(url).then((response) => {
        this.withdraws = response.data.withdraws;
      });
    },
    async showregistration() {
      this.member_id = this.$route.query.id;
      let url = `/profileregistrationfees/${this.member_id}`;
      await axios.get(url).then((response) => {
        this.registrationfees = response.data.registrationfees;
      });
    },
    async showmembership() {
      this.member_id = this.$route.query.id;
      let url = `/profilemembershipfees/${this.member_id}`;
      await axios.get(url).then((response) => {
        this.membershipfees = response.data.membershipfees;
      });
    },
    async showshares() {
      this.member_id = this.$route.query.id;
      let url = `/profileshares/${this.member_id}`;
      await axios.get(url).then((response) => {
        this.shares = response.data.shares;
      });
    },
    async showloans() {
      this.member_id = this.$route.query.id;
      let url = `/profileloans/${this.member_id}`;
      await axios.get(url).then((response) => {
        this.loans = response.data.loans;
        setTimeout(() => { window.print(); window.onafterprint = this.$router.go(-1); }, 1000);
      });
    },
  },
};
</script>